import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  InputLabel,
} from "@mui/material";
import { StyledDialog } from "../../../common/components/Dialog";
import { StyledButton } from "../../../common/components/Button";
import { yupResolver } from "@hookform/resolvers/yup";
import { updatePatient } from "../../../api/patientApi";
import { FormControl } from "@mui/material";
import { StyledTextField } from "../../../common/components/TextField/styles";
import { Select } from "@mui/material";
import { MenuItem } from "@mui/material";
import { FormHelperText } from "@mui/material";
import { TextField } from "@mui/material";
import { Controller } from "react-hook-form";
import { getAllSources } from "../../../api/sourcesApi";
import { Autocomplete } from "@mui/material";
import { updatePatientSchema } from "../schema/updatePatientSchema";
import DateInput from "../../../common/components/Input";
import { toISOStringWithTimezone } from "../../../common/helpers/normalizeDateTime";
const UpdatePatientDialog = ({
  openUpdatePatient,
  handleCloseUpdatePatient,
  caseDetails,
  fetchCase,
}) => {
  const {
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
    register,
    control,
  } = useForm({
    resolver: yupResolver(updatePatientSchema),
  });

  const [sources, setSources] = useState([]);

  useEffect(() => {
    let defaultValues = {};
    defaultValues.patientId = caseDetails.patient.id;
    defaultValues.firstName = caseDetails.patient.firstName;
    defaultValues.lastName = caseDetails.patient.lastName;
    defaultValues.contactNumber = caseDetails.patient.contactNumber;
    defaultValues.email = caseDetails.patient.email;
    defaultValues.address = caseDetails.patient.address;
    defaultValues.dateOfBirth = caseDetails.patient.dateOfBirth;
    defaultValues.sex = caseDetails.patient.sex;
    defaultValues.sourceId = caseDetails.patient.source.id;
    reset({ ...defaultValues });

    const fetchSources = async () => {
      const response = await getAllSources();
      setSources(response);
    };

    fetchSources();
  }, [caseDetails, reset]);

  const submitUpdatePatient = async (values) => {
    console.log(values.dateOfBirth);
    console.log(new Date(values.dateOfBirth).toISOString());
    console.log(toISOStringWithTimezone(values.dateOfBirth));
    await updatePatient(values);
    await fetchCase();
    handleCloseUpdatePatient();
  };

  return (
    <div>
      <StyledDialog
        open={openUpdatePatient}
        onClose={handleCloseUpdatePatient}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle> Update Patient</DialogTitle>

        <form onSubmit={handleSubmit(submitUpdatePatient)}>
          <DialogContent dividers>
            <Grid container direction="row">
              <Grid item xs={10}>
                <StyledTextField
                  label="Last Name"
                  style={{ width: "100%" }}
                  id="lastName"
                  variant="outlined"
                  error={Boolean(errors.lastName)}
                  helperText={errors.lastName?.message}
                  {...register("lastName")}
                />
              </Grid>
              <Grid item xs={10}>
                <StyledTextField
                  style={{ width: "100%" }}
                  label="First Name"
                  id="firstName"
                  variant="outlined"
                  error={Boolean(errors.firstName)}
                  helperText={errors.firstName?.message}
                  {...register("firstName")}
                />
              </Grid>
              <Grid item xs={10}>
                <StyledTextField
                  label="Email"
                  style={{ width: "100%" }}
                  id="email"
                  type="email"
                  variant="outlined"
                  error={Boolean(errors.email)}
                  helperText={errors.email?.message}
                  {...register("email")}
                />
              </Grid>
              <Grid item xs={10}>
                <StyledTextField
                  label="Contact Number"
                  style={{ width: "100%" }}
                  id="contactNumber"
                  variant="outlined"
                  error={Boolean(errors.contactNumber)}
                  helperText={errors.contactNumber?.message}
                  {...register("contactNumber")}
                />
              </Grid>
              <Grid item xs={10}>
                <StyledTextField
                  label="Address"
                  style={{ width: "100%" }}
                  id="address"
                  type="text"
                  variant="outlined"
                  error={Boolean(errors.address)}
                  helperText={errors.address?.message}
                  {...register("address")}
                />
              </Grid>
              <Grid item xs={10}>
                <FormControl
                  error={Boolean(errors.sex)}
                  sx={{ width: "100%", marginBottom: "20px" }}
                >
                  <InputLabel>Sex</InputLabel>
                  <Select
                    label="Sex"
                    {...register("sex")}
                    defaultValue={caseDetails?.patient?.sex}
                  >
                    <MenuItem value="Male">Male</MenuItem>
                    <MenuItem value="Female">Female</MenuItem>
                  </Select>
                  <FormHelperText error={true}>
                    {errors.sex?.message}
                  </FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={10}>
                <DateInput
                  label="Date of Birth"
                  style={{ width: "100%" }}
                  control={control}
                  name="dateOfBirth"
                />
              </Grid>
              <Grid item xs={10}>
                <Controller
                  control={control}
                  name="sourceId"
                  render={({ field: { onChange }, fieldState: { error } }) => (
                    <Autocomplete
                      autoHighlight
                      defaultValue={caseDetails.patient.source.name}
                      disablePortal
                      options={sources}
                      onChange={(_, val) => {
                        onChange(val?.id || "");
                      }}
                      getOptionLabel={(option) => option.name || option}
                      renderInput={(params) => (
                        <TextField
                          label="Source"
                          {...params}
                          error={Boolean(error)}
                          FormHelperTextProps={{ variant: "standard" }}
                          helperText={error && error.message}
                        />
                      )}
                      renderOption={(props, option) => {
                        return (
                          <li {...props} key={option.id}>
                            {option.name}
                          </li>
                        );
                      }}
                      sx={{ width: "100%" }}
                    />
                  )}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <StyledButton
              theme="purple"
              type="button"
              disabled={isSubmitting}
              onClick={handleCloseUpdatePatient}
            >
              Cancel
            </StyledButton>
            <StyledButton theme="green" type="submit" disabled={isSubmitting}>
              Submit
            </StyledButton>
          </DialogActions>
        </form>
      </StyledDialog>
    </div>
  );
};

export default UpdatePatientDialog;
